async function addGiftToCart() {
    const giftId = window.Shopify.autoAddProductId;
    const minCartSum = window.Shopify.autoAddProductTreshold;

    if (!giftId || !minCartSum) {
        return
    }

    const resp = await fetch('/cart.js');
    const cartData = await resp.json();

    let hasGift = false;
    let totalQty = 0;

    for (const item of cartData.items) {
        totalQty += item.quantity;
        if (item.id === giftId) {
            if (item.quantity > 1) {
                await updateProductQTY(item.id, 1)
            }
            hasGift = true;
        }
    }

    const total = (cartData.total_price / 100)

    let actionResponse = {};
    let hasAction = false;
    if (!hasGift && total >= minCartSum) {
        hasAction = true;
        await addProduct(giftId)
        const r = await fetch('/cart.js');
        const cartData3 = await r.json();
        actionResponse = cartData3;
    } else if (hasGift && total < minCartSum) {
        hasAction = true
        actionResponse = await updateProductQTY(giftId, 0)
    }

    if (hasAction) {
        setTimeout(() => {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: {
                    cart: actionResponse
                }
            }));
        }, 150)
    }
}

async function addProduct(id) {
    const resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            items: [
                {
                    quantity: 1,
                    id: id.toString(),
                }
            ]
        })
    });

    return resp.json();
}

async function updateProductQTY(id, qty) {
    const resp = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(
            {
                id: id.toString(),
                quantity: qty
            }
        )
    });

    return resp.json();
}

if (!Shopify.design_mode) {
    document.addEventListener('cartState:change', async function (event) {
        await addGiftToCart();
    });

    document.addEventListener('cart:updated', async function (event) {
        await addGiftToCart();
    });
}